<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->

                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        
                        <!--Timezone-->
                         <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Class :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="classesMasterId"
                                          name="classesMasterId"
                                          id="classesMasterId"
                                          label="text"
                                          :filterable="true"
                                          :options="classesMasterOptions"
                                          @input="onChangeClass()"
                                          placeholder="Select Class">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{classesMasterError}}</span>
                            </div>
                        </div>

                        <!--Class Name-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Class Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="classNameError = ''" class="form-control" id="firstName" placeholder="Enter Class Name" v-model="className">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{classNameError}}</span>
                            </div>
                        </div> -->

                        <!--Class Type-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Class Type :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="classTypeId"
                                          name="classTypeId"
                                          id="classTypeId"
                                          label="text"
                                          :filterable="true"
                                          :options="classTypeOptions"
                                          @input="onChangeClassType()"
                                          placeholder="Select Class Type">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{classTypeError}}</span>
                            </div>
                        </div>
                        <!--Timezone-->
                         <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Timezone :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="timezoneId"
                                          name="timezoneId"
                                          id="timezoneId"
                                          label="text"
                                          :filterable="true"
                                          :options="timezoneOptions"
                                          placeholder="Select Timezone">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{timezoneError}}</span>
                            </div>
                        </div>

                        <template v-if="classTypeId.value == 'recurring'">
                            <!--Recurring Type-->
                            <div class="RecursiveType col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="recursiveType">Recurring Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="recursiveType"
                                              name="recursiveType"
                                              @input="changedValueRecType()"
                                              id="recursiveType"
                                              label="text"
                                              :filterable="false"
                                              :searchable="false"
                                              :options="recursiveTypeArr"
                                              placeholder="Select Recurring Type">
                                    </v-select>
                                    <font class="text-danger">{{rectypeError}}</font>
                                </div>
                            </div>
                        </template>

                        <template  v-if="classTypeId.value === 'recurring' && recursiveType.value === 'weekly'">
                            <div class="WeekDay col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="weekDays">Day Of Week :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="weekDays"
                                              name="weekDays"
                                              @input="changedValueWeekDays()"
                                              id="weekDays"
                                              label="text"
                                              :filterable="false"
                                              :searchable="false"
                                              :options="weekDaysArr"
                                              placeholder="Select Day Of Week">
                                    </v-select>
                                    <font class="text-danger">{{weekDaysError}}</font>
                                </div>
                            </div>
                        </template>

                        <template v-if="classTypeId.value == 'multipledate'">
                            <div class="col-12 forms-block">
                                <button class="btn btn-success" @click="addRow"> <i class="fa fa-plus" aria-hidden="false"></i> </button>
                                <span>Click to Add More</span>
                            </div>
                            <div class="clearfix"></div>

                            <template v-for="(input, index) in inputs">
                                <div class="col-1 forms-block">
                                    <button class="btn btn-danger" @click="deleteRow(index)"><i class="fa fa-times"></i></button>
                                </div>

                                <div class="col-12 forms-block d-flex justify-content-between">
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="startDate" slot="before">Date :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <!--<span class="form-control">12/15/2020</span>-->
                                            <datePicker ref="datepicker" @input="commonError = ''" placeholder="Select Date" id="startDate" v-model="input.startDate" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="startDate" slot="before">Start Time :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <v-select v-model="input.startTime"
                                                      name="startTime"
                                                      @input="changeStartTime()"
                                                      id="startTime"
                                                      label="text"
                                                      :filterable="false"
                                                      :searchable="false"
                                                      :options="timeArray"
                                                      placeholder="Select Start Time">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="startDate" slot="before">End Time :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <v-select v-model="input.endTime"
                                                      name="endTime"
                                                      @input="changeEndTime()"
                                                      id="endTime"
                                                      label="text"
                                                      :filterable="false"
                                                      :searchable="false"
                                                      :options="timeArray"
                                                      placeholder="Select End Time">
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="clearfix"></div>
                            <div class="col-md-2 forms-block">
                            </div>
                            <div class="col-md-5  forms-block">
                                <span class="help is-danger">{{commonError}}</span>
                            </div>
                        </template>



                        <template v-if="classTypeId.value === 'normal'
                        || (classTypeId.value == 'recurring' && recursiveType.value == 'monthly')
                        || (classTypeId.value == 'recurring' && recursiveType.value == 'yearly')
                         || (classTypeId.value == 'recurring' && recursiveType.value == 'weekly')
                        ">
                            <!--Date-->
                            <div class="col-12 forms-block d-flex justify-content-between">
                                <template v-if="classTypeId.value === 'normal'
                        || (classTypeId.value == 'recurring' && recursiveType.value == 'monthly')
                        || (classTypeId.value == 'recurring' && recursiveType.value == 'weekly') || (classTypeId.value == 'recurring' && recursiveType.value == 'yearly')
                        ">
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="startDate" slot="before">Date :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <!--<span class="form-control">12/15/2020</span>-->
                                        <datePicker ref="datepicker" placeholder="Select Date" id="startDate" v-model="startDate" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{startDateError}}</font>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="startTime" slot="before">Start Time :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <v-select v-model="startTime"
                                                  name="startTime"
                                                  @input="changeStartTime()"
                                                  id="startTime"
                                                  label="text"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="timeArray"
                                                  placeholder="Select Start Time">
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{startTimeError}}</font>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="col-12 paddingleft0">
                                        <div class="form-label" for="endTime" slot="before">End Time :</div>
                                    </div>
                                    <div class="col-12 paddingleft0">
                                        <v-select v-model="endTime"
                                                  name="endTime"
                                                  @input="changeEndTime()"
                                                  id="endTime"
                                                  label="text"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="timeArray"
                                                  placeholder="Select End Time">
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{endTimeError}}</font>
                                    </div>
                                </div>
                                </template>
                                <template v-else>
                                    <!-- Here -->
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="startTime" slot="before">Start Time :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <v-select v-model="startTime"
                                                      name="startTime"
                                                      @input="changeStartTime()"
                                                      id="startTime"
                                                      label="text"
                                                      :filterable="false"
                                                      :searchable="false"
                                                      :options="timeArray"
                                                      placeholder="Select Start Time">
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <font class="text-danger">{{startTimeError}}</font>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="col-12 paddingleft0">
                                            <div class="form-label" for="endTime" slot="before">End Time :</div>
                                        </div>
                                        <div class="col-12 paddingleft0">
                                            <v-select v-model="endTime"
                                                      name="endTime"
                                                      @input="changeEndTime()"
                                                      id="endTime"
                                                      label="text"
                                                      :filterable="false"
                                                      :searchable="false"
                                                      :options="timeArray"
                                                      placeholder="Select End Time">
                                            </v-select>
                                            <div class="requiredstar">*</div>
                                            <font class="text-danger">{{endTimeError}}</font>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>

                        <!--Meeting Link-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Meeting Link:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="classMeetingLinkError = ''" class="form-control" id="classMeetingLink" placeholder="Enter Class Meeting Link" v-model="classMeetingLink">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{classMeetingLinkError}}</span>
                            </div>
                        </div>

                        <!--Dependent Classes-->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="cutoffTime" slot="before">Dependent Classes :</div>
                            </div>
                            <div class="col-9 paddingleft0">

                                <v-select
                                        multiple
                                        v-model="dependentClass"
                                        name="dependentClass"
                                        @input="dependentClassError = ''"
                                        label="text"
                                        :filterable="false"
                                        :options="dependentClassArray"
                                        @search="onSearchClasses"
                                        :clearable="false"
                                        placeholder="Select Dependent Classes"
                                        :disabled="false">
                                        <span slot="no-options" @click="$refs.select.open = false">
                                            <template v-if="!isClassRecordNotFound">
                                                Search Classes...
                                            </template>
                                            <template v-else>
                                                No Record Found
                                            </template>
                                        </span>
                                </v-select>
                            </div>
                        </div> -->

                        <!--Deadline/cut-of time-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="cutoffTime" slot="before">Deadline/Cut-of time (Days) :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="cutoffTime"
                                          name="cutoffTime"
                                          @input="changeCutoffTime()"
                                          id="cutoffTime"
                                          label="text"
                                          :filterable="false"
                                          :searchable="false"
                                          :options="cutoffTimeArray"
                                          placeholder="Select Cutoff Time">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <font class="text-danger">{{cutoffTimeError}}</font>
                            </div>
                        </div>

                        <!--Participation Cap-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Participation Cap :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="participationCapError = ''" class="form-control" id="participationCap" placeholder="Enter Participation Cap" v-model="participationCap">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{participationCapError}}</span>
                            </div>
                        </div>

                        <!--Description-->
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label">Description :</div>
                            </div>
                            <div class="col-12 paddingleft0">
                                <!--<textarea class="form-control" id="description" placeholder="Enter Description" v-model="description"/>-->
                                <vue-editor v-model="contentDescription" :editorToolbar="customToolbar"></vue-editor>
                            </div>
                        </div>

                        <!--Class Image-->
                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-12 upload-img-block">
                            <div class="form-group">
                                <label for="dropzone">Upload Image :</label>
                                <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                >
                                    <div class="dropzone-custom-content">
                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                        <div class="subtitle">Select files from your computer.</div>
                                    </div>
                                </vue-dropzone>
                            </div>
                        </div>-->

                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="addUpdateUser ()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary" v-on:click.prevent="addUpdateUser (flag='Save and Continue')">
                        <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateUser ()"></input>-->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                    </div>
                    

                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import moment from 'moment';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    import VSwatches from 'vue-swatches'

    // Import the styles too, globally
    import "vue-swatches/dist/vue-swatches.css";
    import { ColorPickerPlugin } from '@syncfusion/ej2-vue-inputs';
    Vue.use(ColorPickerPlugin);
    import { VueEditor } from "vue2-editor";

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';



    export default {
        name: 'AddUpdateUser',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
            'datePicker': datePicker,
            VueEditor,
            'vueDropzone': vue2Dropzone,
        },
        data() {
            return {
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: "POST",
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 250, //MB
                    dictFileTooBig: "File is to big ({{filesize}}MB). Max allowed file size is {{maxFilesize}}MB",
                    thumbnailWidth: 150, //px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    dictCancelUpload: 'Cancel',
                    dictRemoveFile: "Remove",
                    acceptedFiles: ".jpg, .jpeg, .png",
                    maxFiles: 1,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    }
                },

                //Files
                docType: '',
                docSize: '',
                docPaths: '',
                isFileUploaded: false,
                fileUploaded: true,
                isDocLoaded: false,
                /* Vue-editoor */
                content: "",
                /* Custom header options */
                customToolbar: [
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"],
                    [{align : ""}, {align : "right"}, {align : "center"}, {align : "justify"}],
                    [{ color: [] }],
                    [{sytle : []}],
                    ["clean"]
                ],
                /* End Vue-editoor */
                pageTitle : "Add Class",

                /* New Vars */
                dependentClass : '',
                dependentClassArray : [],
                dependentClassError : "",
                isClassRecordNotFound : false,

                participationLimit :40,
                participationCap : "",
                participationCapError : "",
                cutoffTime : "",
                cutoffTimeArray : [
                    { text : "1", value : "1" },
                    { text : "2", value : "2" },
                    { text : "3", value : "3" },
                    { text : "4", value : "4" },
                    { text : "5", value : "5" },
                    { text : "6", value : "6" },
                    { text : "7", value : "7" }
                ],
                cutoffTimeError : "",
                inputs: [],
                className : "",
                classNameError : "",
                classMeetingLink : "",
                classMeetingLinkError : "",
                contentDescription : "",

                classTypeId : {
                    'text' : "Normal",
                    'value' : "normal",
                },
                classTypeOptions : [
                    {
                        text : "Normal",
                        value : "normal"
                    },
                    {
                        text : "Recurring",
                        value : "recurring",
                    },
                    {
                        text : "Multipledate",
                        value : "multipledate"
                    }
                ],
                classTypeError : "",

                showDaysWeek : false,
                isClassTypeRecursive : false,
                recursiveType: {value: 'monthly', text: 'Monthly'},
                recursiveTypeArr: [
                    {value: 'weekly', text: 'Weekly'},
                    {value: 'monthly', text: 'Monthly'},
                    {value: 'yearly', text: 'Annual'}
                ],
                rectypeError: '',
                weekDays: {value: '1', text: 'Monday'},
                weekDaysArr: [
                    {value: '1', text: 'Monday'},
                    {value: '2', text: 'Tuesday'},
                    {value: '3', text: 'Wednesday'},
                    {value: '4', text: 'Thursday'},
                    {value: '5', text: 'Friday'},
                    {value: '6', text: 'Saturday'},
                    {value: '7', text: 'Sunday'},
                ],
                weekDaysError : "",
                startDate: '',
                startDateError : '',
                optionsStart: {
                    format: 'MM/DD/YYYY',
                    //collapse: true,
                    //inline: true,
                    //dayViewHeaderFormat: 'MMM DD YYYY hh:mm',
                    minDate: new Date(),
                    maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),
                },
                startTime : "",
                startTimeError : "",
                endTime : "",
                endTimeError : "",
                timeArray : [
                    {value : "9:00 AM", text : "9:00 AM", index:1},
                    {value : "9:30 AM", text : "9:30 AM", index:2},
                    {value : "10:00 AM", text : "10:00 AM", index:3},
                    {value : "10:30 AM", text : "10:30 AM", index:4},
                    {value : "11:00 AM", text : "11:00 AM", index:5},
                    {value : "11:30 AM", text : "11:30 AM", index:6},
                    {value : "12:00 PM", text : "12:00 PM", index:7},
                    {value : "12:30 PM", text : "12:30 PM", index:8},
                    {value : "1:00 PM", text : "1:00 PM", index:9},
                    {value : "1:30 PM", text : "1:30 PM", index:10},
                    {value : "2:00 PM", text : "2:00 PM", index:11},
                    {value : "2:30 PM", text : "2:30 PM", index:12},
                    {value : "3:00 PM", text : "3:00 PM", index:13},
                    {value : "3:30 PM", text : "3:30 PM", index:14},
                    {value : "4:00 PM", text : "4:00 PM", index:15},
                    {value : "4:30 PM", text : "4:30 PM", index:16},
                    {value : "5:00 PM", text : "5:00 PM", index:17},
                    {value : "5:30 PM", text : "5:30 PM", index:18},
                    {value : "6:00 PM", text : "6:00 PM", index:19},
                    {value : "6:30 PM", text : "6:30 PM", index:20},
                    {value : "7:00 PM", text : "7:00 PM", index:21},
                ],
                commonError : "",
                /* End */
                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,

                timezoneOptions : [],
                timezoneError : "",
                selectTimezone : "",
                timezoneId : {
                    'text' : "",
                    'value' : "",
                },

                classesMasterOptions : [],
                classesMasterError : "",
                selectclassesMaster : "",
                classesMasterId : {
                    'text' : "",
                    'value' : "",
                },

                startTimeEndTimeError : false,
            }
        },
        beforeMount: function () {
            self = this;

        },

        watch: {
            classTypeId : function (value) {
                if (typeof (self.$route.params.id) != "undefined" && self.$route.params.id != "" && self.$route.params.id != 0) {

                } else {
                    if (value.value == 'multipledate') {
                        this.inputs = [];
                        this.inputs.push({
                            startDate: this.$store.state.classDate.date,
                            startTime : "",
                            endTime : "",
                        });
                    } else {
                        self.startDate = this.$store.state.classDate.date;
                    }
                }
            }
        },
        mounted: function () {
            self.setActiveMenu('calendarclass');
            EventBus.$emit("menu-selection-changed", "calendarclass");
            $("#alertError").hide();
            self.getAllPermissions();
            self.getAllMasterClasses();
            self.addRow();

            if (typeof (self.$route.params.id) != "undefined" && self.$route.params.id != "" && self.$route.params.id != 0) {
                self.getClassDetailsById();
                self.buttonNames.save = "Update";
                $("#addAndContinueBenifitBtn").hide();
                self.pageTitle = "Edit Class";
                self.$nextTick(function() {
                    let date = new Date();
                    // this.$refs.datepicker.setOption('minDate', date);
                    self.optionsStart.minDate = date;
                });
            } else {
                self.$nextTick(function() {
                    let date = new Date();
                    // this.$refs.datepicker.setOption('minDate', date);
                    this.optionsStart.minDate = date;
                });
                /* For display the selected date as Date while add class*/
                self.startDate = self.$store.state.classDate.date;
            }
            self.getClassesForSelection();

            /* Allowed only number in input */
            self.setInputFilter(document.getElementById("participationCap"), function(value) {
                return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
            });
            self.getAllTimezones();
        },
        beforeDestroy(){
            // EventBus.$off('all-permissions');
        },
        methods: {
            getAllMasterClasses(){
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("class-master", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.classesMasterOptions = data.data.content;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            getAllTimezones(){
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("timezones", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.timezoneOptions = data.data.content;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            removedSelectedFile(file, xhr, error) {
                var removeFile = "";

                if ("manuallyAdded" in file == true) {
                    removeFile = self.docPaths;

                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);

                }
                self.docPaths = '';
                self.docSize = '';
                self.isFileUploaded = false;
                self.isDocLoaded = false;
            },
           /* removedSelectedFile(file, xhr, error) {
                self.docPaths = '';
                self.docSize = '';
                self.isFileUploaded = false;
                self.isDocLoaded = false;
                var filePath = JSON.parse(file.xhr.response);
                if ("media_thumb_path" in filePath.content) {
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },*/
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                    .then(function (response) {

                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            uploadManually(file) {
                if (self.docPaths != '') {
                    var file_name = self.getFileName(self.docPaths);
                    let file_type = self.getFileType(file_name);
                    let url = self.docPaths;
                    let file_size = self.docSize;
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            vfileSuccess: function (file, response) {
                self.docPaths = response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                } else {
                }
                self.docType = file.type;
                self.docSize = file.size;
                self.videoURLError = '';
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.

            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.videoURLError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },
            getWeekDays : function (value) {
                let returnObj = {};
                for (let i = 0; i < self.weekDaysArr.length; i++) {
                    if (self.weekDaysArr[i].value == value) {
                        returnObj.text = self.weekDaysArr[i].text;
                        returnObj.value = self.weekDaysArr[i].value;
                    }
                }

                return returnObj;
            },
            onSearchClasses : function (search, loading) {
                if (search.length > 2) {
                    // loading(true);
                    self.getClassesForSelection(loading, search);
                } else {
                    self.getClassesForSelection(loading, '');
                }
            },
            getClassesForSelection: function (loading, search) {
                self.dependentClassArray = [];
                var fields = {
                    search: search,
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                if (search != null && search != '' && typeof search != "undefined") {
                    // loading(true);
                }
                HTTP.post('/class/getclasses', fields, config).
                then(response => {
                    if (response.data.content.length > 0) {
                        self.isClassRecordNotFound = true;
                        self.dependentClassArray = response.data.content;

                        if (typeof (self.$route.params.id) != "undefined" && self.$route.params.id != "" && self.$route.params.id != 0) {
                            for (let i = 0; i < self.dependentClassArray.length; i++) {
                                if (self.$route.params.id == self.dependentClassArray[i].value) {
                                    self.dependentClassArray.splice(i,1);
                                }
                            }
                        }
                    }
                    // loading(false);
                })
                    .catch(function (err) {
                        // loading(false);
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            getClassDetailsById: function () {
                var fields = {
                    id: self.$route.params.id,
                };

                var config = {
                    headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                };

                HTTP.post('/class/get', fields, config).
                then(response => {
                    self.classesMasterId = { text : response.data.content.class_master_name, value : response.data.content.class_master_id};
                    self.classTypeId = { text : self.capitalizeFirstLetter(response.data.content.class_type), value : response.data.content.class_type};
                    self.timezoneId = {text : response.data.content.timezone_name, value : response.data.content.timezone_id};


                    if (response.data.content.class_type == "multipledate") {
                        self.inputs = response.data.content.inputs;
                    } else if (response.data.content.class_type == "recurring") {
                        self.recursiveType = { text : self.capitalizeFirstLetter(response.data.content.recurring_type), value : response.data.content.recurring_type};
                        if (response.data.content.recurring_type == "weekly") {
                            self.weekDays = self.getWeekDays(response.data.content.week_day);
                            self.startTime = {text : response.data.content.week_start_time, value : response.data.content.week_start_time};
                            self.endTime = {text : response.data.content.week_end_time, value : response.data.content.week_end_time};
                        } else {
                            self.startDate = response.data.content.start_date;
                            self.startTime = {text : response.data.content.start_time, value : response.data.content.start_time};
                            self.endTime = {text : response.data.content.end_time, value : response.data.content.end_time};
                        }
                    } else {
                        self.startDate = response.data.content.start_date;
                        self.startTime = {text : response.data.content.start_time, value : response.data.content.start_time};
                        self.endTime = {text : response.data.content.end_time, value : response.data.content.end_time};
                    }

                    self.dependentClass = response.data.content.depedent_class;
                    self.contentDescription = response.data.content.description;
                    self.classMeetingLink = response.data.content.meeting_link;
                    self.participationCap = response.data.content.participation_cap;
                    self.cutoffTime = {text : response.data.content.cutoff_days, value : response.data.content.cutoff_days};

                    if (response.data.content.doc_path != null && response.data.content.doc_path != '' && typeof response.data.content.doc_path != "undefined") {
                        self.docPaths = response.data.content.doc_path;
                        self.isFileUploaded = true;
                        self.isDocLoaded = true;
                        self.docSize = response.data.content.doc_size;
                        self.uploadManually();
                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                self.$router.push({name : "Login"});
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            addRow() {
                let input_length = this.inputs.length;
                let inputs_limit = 5;
                //alert(this.inputs.length);
                if(input_length == inputs_limit){
                    alert("can't add more than "+inputs_limit+" multiple dates");
                    return;
                }
                if (self.firstAdd) {
                    this.inputs.push({
                        startDate: "",
                        startTime : "",
                        endTime : "",
                    });
                    self.firstAdd = false;
                } else {
                    if (self.checkInput()) {
                        this.inputs.push({
                            startDate: "",
                            startTime : "",
                            endTime : "",
                        });
                    } else {
                        if (self.startTimeEndTimeError == true) {
                            self.commonError = 'Select End Time after the time of Start Time';
                            self.startTimeEndTimeError = false;
                        } else {
                            self.commonError = "Please fill all the details";
                        }
                    }
                }
            },
            deleteRow(index) {
                this.inputs.splice(index,1);
                self.commonError = "";
            },
            changedValueWeekDays: function () {
                self.weekDaysError = "";
            },
            changeStartTime : function() {
                self.startTimeError = "";
                self.commonError = "";
            },
            changeEndTime : function () {
                self.endTimeError = "";
                self.commonError = "";
            },
            changeCutoffTime : function() {
                self.cutoffTimeError = "";
            },
            changeStartDt : function () {
                self.startDateError = "";
            },
            changedValueRecType: function () {
                self.rectypeError = "";
            },
            getAllPermissionsss(){
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.allPermissions = data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push({name : "ClassCalender"});
            },

            clearDataOnSaveAndContinue : function () {
                self.classMeetingLink = '';
                self.dependentClass = '';
                self.participationCap = "";
                self.cutoffTime = "";
                self.inputs = [];
                self.classTypeId = '';
                self.recursiveType = {value: 'monthly', text: 'Monthly'};
                self.weekDays = {value: '1', text: 'Monday'};
                self.startDate = this.$store.state.classDate.date;
                self.startTime = "";
                self.endTime = "";
                self.classesMasterId = '';
                self.contentDescription = "";
            },
            
            onChangeClass : function () {
                self.classesMasterError = "";
            },

            onChangeClassType : function () {
                self.classTypeError = "";
            },

            checkInput: function () {
                var checked = true;
                if (self.classTypeId.value == "multipledate") {
                    for (let i = 0; i < self.inputs.length; i++) {
                        if (self.inputs[i].startTime.value === "" || self.inputs[i].startTime.value === null || typeof self.inputs[i].startTime.value === "undefined") {
                            self.commonError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (self.inputs[i].endTime.value === "" || self.inputs[i].endTime.value === null || typeof self.inputs[i].endTime.value === "undefined") {
                            self.commonError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (!self.inputs[i].startDate) {
                            self.commonError = "Please fill all the details";
                            if (checked) {
                                checked = false;
                            }
                        }

                        var startDateTime = moment(new Date(self.inputs[i].startDate)).format("YYYY/MM/DD") + " " + self.inputs[i].startTime.value;
                        var endDateTime = moment(new Date(self.inputs[i].startDate)).format("YYYY/MM/DD") + " " + self.inputs[i].endTime.value;
                        var fromDate = new Date(Date.parse(startDateTime));
                        var toDate = new Date(Date.parse(endDateTime));

                        if (fromDate > toDate){
                            self.startTimeEndTimeError = true;
                            self.commonError = 'Select End Time after the time of Start Time';
                            if (checked) {
                                checked = false;
                            }
                        }
                        // TODO :: check below if conditions its not working for  the selection of same time
                        if (fromDate == toDate) {
                            self.startTimeEndTimeError = true;
                            self.endTimeError = 'Start Time and End Time should not be same';
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                return checked;
            },

            checkForm: function () {
                var checked = true;

                if (self.classTypeId.value == "multipledate" && !self.checkInput()) {
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.participationCap) {
                    self.participationCapError = "Participation Cap Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.participationCap && self.participationCap > 99){
                    self.participationCapError = "Participation Cap is 99";
                    if (checked) {
                        checked = false;
                    }
                }

                if (self.cutoffTime.value == "" || typeof self.cutoffTime.value == "undefined" || self.cutoffTime.value == null) {
                    self.cutoffTimeError = "Deadline/Cut-of time Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.classesMasterId.value == "" || typeof self.classesMasterId.value == "undefined" || self.classesMasterId.value == null) {
                    self.classesMasterError = "Class Required";
                    if (checked) {
                        checked = false;
                    }
                }

                if (!self.classMeetingLink) {
                    self.classMeetingLinkError = "Class Meeting Required";
                    if (checked) {
                        checked = false;
                    }
                } else if(self.classMeetingLink && !self.isUrlValid(self.classMeetingLink)) {
                    self.classMeetingLinkError  = "Please enter valid url";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.classTypeId.value == "normal" || (self.classTypeId.value == "recurring" && self.recursiveType.value == "monthly") || (self.classTypeId.value == "recurring" && self.recursiveType.value == "yearly")) {
                    var startDateTime = moment(new Date(self.startDate)).format("YYYY/MM/DD") + " " + self.startTime.value;
                    var endDateTime = moment(new Date(self.startDate)).format("YYYY/MM/DD") + " " + self.endTime.value;
                    var fromDate = new Date(Date.parse(startDateTime));
                    var toDate = new Date(Date.parse(endDateTime));

                    if (fromDate > toDate){
                        self.endTimeError = 'Select End Time after the time of Start Time';
                        if (checked) {
                            checked = false;
                        }
                    }
                    // TODO :: check below if conditions its not working for  the selection of same time
                    if (fromDate == toDate) {
                        self.endTimeError = 'Start Time and End Time should not be same';
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (!self.startDate) {
                        self.startDateError = "Date Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.startTime.value == "" || typeof self.startTime.value == "undefined" || self.startTime.value == null) {
                        self.startTimeError = "Start Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.endTime.value == "" || typeof self.endTime.value == "undefined" || self.endTime.value == null) {
                        self.endTimeError = "End Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                /*if (self.classTypeId.value == "normal" || (self.classTypeId.value == "recurring" && self.recursiveType.value == "monthly") || (self.classTypeId.value == "recurring" && self.recursiveType.value == "yearly")) {
                    var startDateTime = moment(new Date(self.startDate)).format("YYYY/MM/DD") + " " + self.startTime.value;
                    var endDateTime = moment(new Date(self.startDate)).format("YYYY/MM/DD") + " " + self.endTime.value;
                    var fromDate = new Date(Date.parse(startDateTime));
                    var toDate = new Date(Date.parse(endDateTime));

                    if (fromDate > toDate){
                        self.endTimeError = 'Select End Time after the time of Start Time';
                        if (checked) {
                            checked = false;
                        }
                    }
                    // TODO :: check below if conditions its not working for  the selection of same time
                    if (fromDate == toDate) {
                        self.endTimeError = 'Start Time and End Time should not be same';
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (!self.startDate) {
                        self.startDateError = "Date Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.startTime.value == "" || typeof self.startTime.value == "undefined" || self.startTime.value == null) {
                        self.startTimeError = "Start Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.endTime.value == "" || typeof self.endTime.value == "undefined" || self.endTime.value == null) {
                        self.endTimeError = "End Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                }*/

                if (self.classTypeId.value == "recurring" && self.recursiveType.value == "weekly") {
                    if (self.startTime.value == "" || typeof self.startTime.value == "undefined" || self.startTime.value == null) {
                        self.startTimeError = "Start Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.endTime.value == "" || typeof self.endTime.value == "undefined" || self.endTime.value == null) {
                        self.endTimeError = "End Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    var startDateTime = moment(new Date()).format("YYYY/MM/DD") + " " + self.startTime.value;
                    var endDateTime = moment(new Date()).format("YYYY/MM/DD") + " " + self.endTime.value;
                    var fromDate = new Date(Date.parse(startDateTime));
                    var toDate = new Date(Date.parse(endDateTime));

                    if (fromDate > toDate){
                        self.endTimeError = 'Select End Time after the time of Start Time';
                        if (checked) {
                            checked = false;
                        }
                    }
                    // TODO :: check below if conditions its not working for  the selection of same time
                    if (fromDate == toDate) {
                        self.endTimeError = 'Start Time and End Time should not be same';
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                /*if (self.classTypeId.value == "recurring" && self.recursiveType.value == "weekly") {
                    if (self.startTime.value == "" || typeof self.startTime.value == "undefined" || self.startTime.value == null) {
                        self.startTimeError = "Start Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (self.endTime.value == "" || typeof self.endTime.value == "undefined" || self.endTime.value == null) {
                        self.endTimeError = "End Time Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                    var startDateTime = moment(new Date()).format("YYYY/MM/DD") + " " + self.startTime.value;
                    var endDateTime = moment(new Date()).format("YYYY/MM/DD") + " " + self.endTime.value;
                    var fromDate = new Date(Date.parse(startDateTime));
                    var toDate = new Date(Date.parse(endDateTime));

                    if (fromDate > toDate){
                        self.endTimeError = 'Select End Time after the time of Start Time';
                        if (checked) {
                            checked = false;
                        }
                    }
                    // TODO :: check below if conditions its not working for  the selection of same time
                    if (fromDate == toDate) {
                        self.endTimeError = 'Start Time and End Time should not be same';
                        if (checked) {
                            checked = false;
                        }
                    }
                }*/

                return checked;
            },

            returnData : function() {
                var data = {};
                if (self.classTypeId.value == "normal") {
                    data = {
                        class_name : self.className,
                        class_type : self.classTypeId.value,
                        start_date : self.startDate,
                        start_time : self.startTime,
                        end_time : self.endTime,
                        description : self.contentDescription,
                        meeting_link : self.classMeetingLink,
                        participation_cap : self.participationCap,
                        cutoff_time : self.cutoffTime.value,
                        dependent_class : self.dependentClass,
                        mediaPath: self.docPaths,
                        mediaType: self.docType,
                        mediaSize: self.docSize,
                        timezone_id: self.timezoneId.value,
                        class_master_id: self.classesMasterId.value,
                    }
                }
                if (self.classTypeId.value == "recurring" && self.recursiveType.value == "monthly") {
                    data = {
                        class_name : self.className,
                        class_type : self.classTypeId.value,
                        recursion_type : self.recursiveType.value,
                        start_date : self.startDate,
                        start_time : self.startTime,
                        end_time : self.endTime,
                        description : self.contentDescription,
                        meeting_link : self.classMeetingLink,
                        participation_cap : self.participationCap,
                        cutoff_time : self.cutoffTime.value,
                        dependent_class : self.dependentClass,
                        mediaPath: self.docPaths,
                        mediaType: self.docType,
                        mediaSize: self.docSize,
                        timezone_id: self.timezoneId.value,
                        class_master_id: self.classesMasterId.value,
                    }
                }
                if (self.classTypeId.value == "recurring" && self.recursiveType.value == "yearly") {
                    data = {
                        class_name : self.className,
                        class_type : self.classTypeId.value,
                        recursion_type : self.recursiveType.value,
                        start_date : self.startDate,
                        start_time : self.startTime,
                        end_time : self.endTime,
                        description : self.contentDescription,
                        meeting_link : self.classMeetingLink,
                        participation_cap : self.participationCap,
                        cutoff_time : self.cutoffTime.value,
                        dependent_class : self.dependentClass,
                        mediaPath: self.docPaths,
                        mediaType: self.docType,
                        mediaSize: self.docSize,
                        timezone_id: self.timezoneId.value,
                        class_master_id: self.classesMasterId.value,
                    }
                }
                if (self.classTypeId.value == "recurring" && self.recursiveType.value == "weekly") {
                    data = {
                        class_name : self.className,
                        class_type : self.classTypeId.value,
                        recursion_type : self.recursiveType.value,
                        start_date : self.startDate,
                        start_time : self.startTime,
                        end_time : self.endTime,
                        week_days : self.weekDays.value,
                        description : self.contentDescription,
                        meeting_link : self.classMeetingLink,
                        participation_cap : self.participationCap,
                        cutoff_time : self.cutoffTime.value,
                        dependent_class : self.dependentClass,
                        mediaPath: self.docPaths,
                        mediaType: self.docType,
                        mediaSize: self.docSize,
                        timezone_id: self.timezoneId.value,
                        class_master_id: self.classesMasterId.value,
                    }
                }
                if (self.classTypeId.value == "multipledate") {
                    data = {
                        class_name : self.className,
                        class_type : self.classTypeId.value,
                        inputs  : self.inputs,
                        description : self.contentDescription,
                        meeting_link : self.classMeetingLink,
                        participation_cap : self.participationCap,
                        cutoff_time : self.cutoffTime.value,
                        dependent_class : self.dependentClass,
                        mediaPath: self.docPaths,
                        mediaType: self.docType,
                        mediaSize: self.docSize,
                        timezone_id: self.timezoneId.value,
                        class_master_id: self.classesMasterId.value,
                    }
                }

                if (typeof (self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                    data.id = self.$route.params.id;
                }

                return data;
            },

            addUpdateUser (flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:"Bearer " + localStorage.getItem("api_token")},
                        };

                        if (segments[1] == 'update-class') {
                            if (segments[2]) {
                                var data = self.returnData();
                                self.buttonNames.save = "Updating ...";
                                self.disableButtons.save = true;
                                self.disableButtons.cancel = true;
                            } else {
                                if (flag == "Save and Continue") {
                                    self.buttonNames.saveAndContinue = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                } else {
                                    self.buttonNames.save = "Saving ...";
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                }
                            }
                        } else {
                            var data = self.returnData();
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }


                        HTTP.post("/class/add", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-class') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                if (response.data.status === "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if (segments[1] == 'update-class') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }

    }

    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            // if (segments[1] === 'update-class') {
            //     self.getClassDetailsById();
            // }
            // self.allPermissions = allPermissions;
        }
    });
</script>

<style>
    .startDate{
        float: left;
        font-size: 20px;
        padding-top: 0.17em;
    }

    .startTime{
        float: right;
        font-size: 20px;
        padding-top: 0.17em;
    }

    .endTime{
        display: inline;
        font-size: 30px;
        padding-right: 2.5%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Class/AddUpdateClass.vue